function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.22 1.867h7.298c.596 0 1.043.447 1.043 1.043v7.298c0 .595-.447 1.042-1.043 1.042H2.221a1.018 1.018 0 01-1.043-1.042V2.91c-.074-.596.447-1.043 1.043-1.043zM7.88.75v2.16M3.71.75v2.16M1.252 4.92h9.234",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCalenderIcon = function SvgCalenderIcon(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref);
};

export default SvgCalenderIcon;